var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "component-root" },
    [
      _c("h1", [
        _vm._v(_vm._s(_vm.resource("JourneyBuilder_JourneyReport_Title")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-auto" },
          [
            _c("navigate-to-journey-button", {
              attrs: { "journey-id": _vm.journeyId, disabled: !_vm.journeyId }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-auto" },
          [_c("navigate-to-overview-button")],
          1
        )
      ]),
      _vm._v(" "),
      _c("bootstrap-box", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("div", { staticClass: "mb-3" }, [
                  _c("i", { staticClass: "fas fa-project-diagram" }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "box-title" }, [
                    _vm._v(
                      _vm._s(_vm.resource("JourneyBuilder_JourneyReport_Title"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("journey-statistics-configuration")
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _vm.isReady ? _c("journey-statistics-sankey") : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }